class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const removeFilterNode = this.querySelector('a')
    removeFilterNode.addEventListener('click', (e) => {
      e.preventDefault();

      if (removeFilterNode.classList.contains('m-active-facets--remove-all')) {
        const customFiltersForm = document.querySelector('custom-filters-form');
        customFiltersForm?.resetAll();
      }
      
      const filtersForm = this.closest('collection-filters-form') || document.querySelector('collection-filters-form');
      filtersForm.renderPage(new URL(removeFilterNode.href).searchParams.toString());
    });
  }
}

customElements.define('facet-remove', FacetRemove);